export default __webpack_public_path__ + "static/fininscase1-259bfa910257c307117cd27751274296.png";